import { useEffect, useState } from "react";
import { readDays, saveDay } from "../utils/scheduleStore";

export default function useWeekScheduleData({
  weekDates,
  ymd,
  normalizeDay,
  serializeDay,
}) {
  const [weekDaysData, setWeekDaysData] = useState({});
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadWeek() {
      setLoading(true);
      setErrMsg("");

      try {
        const isoDates = weekDates.map((d) => ymd(d));
        const data = await readDays(isoDates);
        if (cancelled) return;

        const normalized = {};
        for (const iso of isoDates) {
          normalized[iso] = normalizeDay(data?.[iso] || {});
        }

        console.log(
          "LOADED MEDICAL HQ EXTRAS BY DAY",
          JSON.stringify(
            isoDates.map((iso) => ({
              iso,
              extras: normalized[iso]?.["__extraSlots"]?.["Medical HQ"] || [],
            })),
            null,
            2
          )
        );

        setWeekDaysData(normalized);
      } catch (e) {
        console.error("ScheduleBoard readDays error:", e);
        if (!cancelled) {
          setErrMsg(e?.message || "Unable to load schedules.");
          setWeekDaysData({});
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadWeek();

    return () => {
      cancelled = true;
    };
  }, [weekDates, ymd, normalizeDay]);

  async function commitDay(iso, nextDay) {
    const serialized = serializeDay(nextDay);
    await saveDay(iso, serialized);
    setWeekDaysData((prev) => ({
      ...(prev || {}),
      [iso]: normalizeDay(serialized),
    }));
  }

  return {
    weekDaysData,
    setWeekDaysData,
    loading,
    errMsg,
    commitDay,
  };
}